import { z } from 'zod';
import { validateState } from '../ValidateState.ts';
/**
 * Trade offer ids are four characters from the same alphabet as RandomUtils.randomStringId in
 * @colonist/utils (excludes ambiguous 0, 1, I, l, O).
 */ const TRADE_ID_LENGTH = 4;
const TRADE_ID_PATTERN = /^[A-HJ-NP-Za-km-z2-9]{4}$/;
export const tradeIdSchema = z.string().length(TRADE_ID_LENGTH).regex(TRADE_ID_PATTERN);
export function validateTradeId(data) {
    return validateState(tradeIdSchema, data);
}
